import { useState } from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../../../ui/tabs';
import { MapView } from './MapView';
import { ListView } from './ListView';
import { MapIcon, ListChecks } from 'lucide-react';

export function SearchJobs() {
  const [activeViewTab, setActiveViewTab] = useState('list');

  return (
    <div className="max-w-4xl mx-auto space-y-8 py-8">
      {/* Page Title */}
      <div className="text-center space-y-4">
        <h1 className="text-3xl md:text-5xl font-bold text-black">Find Jobs Near You</h1>
        <p className="text-xl text-gray-600">Discover work opportunities in your neighborhood</p>
      </div>

      {/* View Toggle */}
      <div className="flex justify-center">
        <Tabs value={activeViewTab} onValueChange={setActiveViewTab} className="w-full max-w-md">
          <TabsList className="grid w-full grid-cols-2 bg-white shadow-lg border p-2 rounded-xl h-16">
            <TabsTrigger
              value="list"
              className="flex items-center gap-2 data-[state=active]:bg-black data-[state=active]:text-white text-lg font-medium h-full transition-all duration-200"
            >
              <ListChecks className="w-4 h-4" />
              List View
            </TabsTrigger>
            <TabsTrigger
              value="map"
              className="flex items-center gap-2 data-[state=active]:bg-black data-[state=active]:text-white text-lg font-medium h-full transition-all duration-200"
            >
              <MapIcon className="w-4 h-4" />
              Map View
            </TabsTrigger>
          </TabsList>
        </Tabs>
      </div>

      {/* Content Views */}
      <Tabs value={activeViewTab} onValueChange={setActiveViewTab} className="w-full">
        <TabsContent value="list">
          <ListView />
        </TabsContent>
        <TabsContent value="map">
          <MapView />
        </TabsContent>
      </Tabs>
    </div>
  );
}